(function () {
  if (window.__luxPurchaseToastInitialized) return;
  window.__luxPurchaseToastInitialized = true;

  var toast = document.querySelector('[data-lux-purchase-toast]');
  var jsonNode = document.getElementById('LuxPurchaseToastData');

  if (!toast || !jsonNode) return;

  var products = [];
  try {
    products = JSON.parse(jsonNode.textContent || '[]');
  } catch (error) {
    return;
  }

  products = products.filter(function (item) {
    return item && item.title && item.url;
  });

  if (!products.length) return;

  var dismissKey = 'luxPurchaseToastDismissed';
  try {
    if (window.sessionStorage.getItem(dismissKey) === '1') return;
  } catch (error) {
    /* Keep running if sessionStorage is blocked */
  }

  var link = toast.querySelector('[data-lux-purchase-link]');
  var imageWrap = toast.querySelector('[data-lux-purchase-image-wrap]');
  var image = toast.querySelector('[data-lux-purchase-image]');
  var title = toast.querySelector('[data-lux-purchase-title]');
  var location = toast.querySelector('[data-lux-purchase-location]');
  var time = toast.querySelector('[data-lux-purchase-time]');
  var closeButton = toast.querySelector('[data-lux-purchase-close]');

  var cities = ['Mumbai', 'Delhi', 'Bengaluru', 'Pune', 'Ahmedabad', 'Hyderabad', 'Surat'];
  var showTimeout;
  var hideTimeout;
  var lastProductIndex = -1;

  function randomIndex(length) {
    if (length <= 1) return 0;

    var index = Math.floor(Math.random() * length);
    while (index === lastProductIndex) {
      index = Math.floor(Math.random() * length);
    }

    return index;
  }

  function randomCity() {
    return cities[Math.floor(Math.random() * cities.length)];
  }

  function randomMinutes() {
    return Math.floor(Math.random() * 45) + 5;
  }

  function clearTimers() {
    window.clearTimeout(showTimeout);
    window.clearTimeout(hideTimeout);
  }

  function paintToast(item) {
    var minutes = randomMinutes();
    link.setAttribute('href', item.url);
    title.textContent = item.title;
    location.textContent = '(' + randomCity() + ')';
    time.textContent = minutes + (minutes === 1 ? ' minute ago' : ' minutes ago');

    if (item.image) {
      image.src = item.image;
      image.alt = item.title;
      imageWrap.classList.remove('is-empty');
      return;
    }

    image.removeAttribute('src');
    image.alt = '';
    imageWrap.classList.add('is-empty');
  }

  function scheduleShow(delay) {
    clearTimers();
    showTimeout = window.setTimeout(showToast, delay);
  }

  function showToast() {
    if (document.hidden) {
      scheduleShow(2000);
      return;
    }

    var nextIndex = randomIndex(products.length);
    lastProductIndex = nextIndex;
    paintToast(products[nextIndex]);

    toast.hidden = false;
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    hideTimeout = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      showTimeout = window.setTimeout(showToast, 60000);
    }, 6000);
  }

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      clearTimers();
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.hidden = true;
      }, 300);

      try {
        window.sessionStorage.setItem(dismissKey, '1');
      } catch (error) {
        /* Ignore write failures */
      }
    });
  }

  window.addEventListener('pagehide', clearTimers);
  scheduleShow(30000);
})();
